export default $sce => ({
  restrict: "A", // only activate on element attribute
  require: "?ngModel", // get a hold of NgModelController
  link(scope, element, attrs, ngModel) {
    if (!ngModel) return; // do nothing if no ng-model

    const initialValue = scope.$eval(attrs.ngModel);
    element.html(initialValue);
    // Specify how UI should be updated
    ngModel.$render = function() {
      const html = $sce.getTrustedHtml(ngModel.$viewValue || "");
      element.html(html);
    };

    // Listen for change events to enable binding
    element.on("blur keyup change", function() {
      scope.$evalAsync(read);
    });
    read(); // initialize

    // Write data to the model
    function read() {
      var html = element.html();
      // When we clear the content editable the browser leaves a <br> behind
      // If strip-br attribute is provided then we strip this out
      if (attrs.stripBr && html == "<br>") {
        html = "";
      }
      ngModel.$setViewValue(html);
    }
  }
});

/*

'use strict';

angular.module('CEDemoApp', [])
 
  .controller('CEDemoCtrl', ['$scope', function($scope) {
    $scope.value = "click here to edit me";
  }])

    .directive("contenteditable", function () {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs, ngModel) {
              	// read is the main handler, invoked here by the blur event
                function read() {
                  	// Keep the newline value for substitutin
                  	// when cleaning the <br>
                    var newLine = String.fromCharCode(10);
                  	// Firefox adds a <br> for each new line, we replace it back
                  	// to a regular '\n'
                    var formattedValue = element.html().replace(/<br>/ig,newLine).replace(/\r/ig,'');
                  	// update the model
                    ngModel.$setViewValue(formattedValue);
                  	// Set the formated (cleaned) value back into
                  	// the element's html.
                    element.text(formattedValue);
                }

                ngModel.$render = function () {
                    element.html(ngModel.$viewValue || "");
                };

                element.bind("blur", function () {
                  	// update the model when
                  	// we loose focus
                    scope.$apply(read);
                });
                element.bind("paste", function(e){
                  	// This is a tricky one
                  	// when copying values while
                  	// editing, the value might be
                  	// copied with formatting, for example
                  	// <span style="line-height: 20px">copied text</span>
                  	// to overcome this, we replace
                  	// the default behavior and
                  	// insert only the plain text
                  	// that's in the clipboard
                    e.preventDefault();
                    document.execCommand('inserttext', false, e.clipboardData.getData('text/plain'));
                });
            }
        };
    });*/
